import React from 'react';

function PageHeader({ icon: Icon, title, subtitle, actions, children }) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.bar}>
        <div style={styles.left}>
          {Icon && <Icon size={22} color="#6366f1" />}
          <div>
            <h1 style={styles.title}>{title}</h1>
            {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
          </div>
        </div>
        {actions && <div style={styles.right}>{actions}</div>}
      </div>
      {children && <div style={styles.children}>{children}</div>}
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    marginBottom: 0,
  },
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px',
    minHeight: 28,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: '#0f172a',
    margin: 0,
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: 13,
    color: '#64748b',
    margin: '4px 0 0',
    lineHeight: 1.4,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  children: {
    padding: '0 24px 14px',
  },
};

export default PageHeader;
